// NeevStarLogo.js — SVG logo component, renders at any size
// Usage: <NeevStarLogo size="full" /> or <NeevStarLogo size="icon" />
import React from 'react';

// Full logo — N mark + "neevstar" + tagline
export function NeevStarLogoFull({ width = 260, dark = false }) {
  const textColor = dark ? 'white' : '#0D1B4B';
  const subColor  = dark ? 'rgba(255,255,255,0.55)' : '#0D1B4B';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 160" width={width} style={{ display:'block' }}>
      <defs>
        <linearGradient id="ng_full" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor={dark ? '#6B8EE8' : '#0D1B4B'}/>
          <stop offset="100%" stopColor={dark ? '#A0C4FF' : '#1A3A8F'}/>
        </linearGradient>
        <filter id="glow_full">
          <feGaussianBlur in="SourceGraphic" stdDeviation="2.5" result="blur"/>
          <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>

      {/* N letterform */}
      <path d="M18 118 L18 28" stroke="url(#ng_full)" strokeWidth="18" strokeLinecap="round" fill="none"/>
      <path d="M112 118 L112 28" stroke="url(#ng_full)" strokeWidth="18" strokeLinecap="round" fill="none"/>
      <path d="M18 28 Q65 75 112 28" stroke="url(#ng_full)" strokeWidth="13" strokeLinecap="round" fill="none"/>
      {/* Growth curve */}
      <path d="M112 28 Q130 10 148 4" stroke="#E8B800" strokeWidth="5" strokeLinecap="round" fill="none" filter="url(#glow_full)"/>
      {/* Star */}
      <g transform="translate(152,2)" filter="url(#glow_full)">
        <path d="M8 0 L10 6 L16 6 L11 9.5 L13 16 L8 12.5 L3 16 L5 9.5 L0 6 L6 6 Z"
          fill="#FFD700" stroke="#E8B800" strokeWidth="0.5"/>
      </g>

      {/* Wordmark */}
      <text x="148" y="96"
        fontFamily="'Nunito','Poppins',system-ui,sans-serif"
        fontSize="62" fontWeight="900" letterSpacing="-1"
        fill={textColor}>neev</text>
      <text x="302" y="96"
        fontFamily="'Nunito','Poppins',system-ui,sans-serif"
        fontSize="62" fontWeight="900" letterSpacing="-1"
        fill="#E8B800">star</text>

      {/* Tagline */}
      <text x="150" y="126"
        fontFamily="'Nunito',system-ui,sans-serif"
        fontSize="13" fontWeight="700" letterSpacing="2"
        fill={subColor} opacity="0.55">Learn Today. Lead Tomorrow.</text>
    </svg>
  );
}

// Icon only — N mark in rounded square (for nav, badges, small use)
export function NeevStarIcon({ size = 40, rounded = true }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={size} height={size} style={{ display:'block' }}>
      <defs>
        <linearGradient id="ng_icon" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0D1B4B"/>
          <stop offset="100%" stopColor="#1A3A8F"/>
        </linearGradient>
        <filter id="glow_icon">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" result="blur"/>
          <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>
      {rounded && <rect width="100" height="100" rx="22" fill="url(#ng_icon)"/>}
      {/* N */}
      <path d="M22 78 L22 22" stroke="white" strokeWidth="11" strokeLinecap="round" fill="none"/>
      <path d="M68 78 L68 22" stroke="white" strokeWidth="11" strokeLinecap="round" fill="none"/>
      <path d="M22 22 Q45 50 68 22" stroke="white" strokeWidth="8" strokeLinecap="round" fill="none"/>
      {/* Growth curve */}
      <path d="M68 22 Q78 12 88 7" stroke="#FFD700" strokeWidth="3.5" strokeLinecap="round" fill="none" filter="url(#glow_icon)"/>
      {/* Star */}
      <g transform="translate(84,3)" filter="url(#glow_icon)">
        <path d="M5 0 L6.5 4 L11 4 L7.5 6.5 L9 11 L5 8.5 L1 11 L2.5 6.5 L-1 4 L3.5 4 Z"
          fill="#FFD700"/>
      </g>
    </svg>
  );
}

export default NeevStarLogoFull;
